document.addEventListener("DOMContentLoaded", function () {

    const sort = document.getElementById("SortBy");

    if(sort){

        sort.addEventListener("change", function(){

            const url = new URL(window.location.href);

            url.searchParams.set("sort_by", this.value);

            window.location.href = url.toString();

        });

    }

});